import { Box, Grid, Typography } from "@mui/material";
import PTTranslate from "./PTTranslate";
import PTTypography from "./PTTypography";
import PTTooltip from "./PTTooltip";
import PTIcon from "./PTIcon";

export const PTTextDisplay = ({
  label,
  value,
  isHidden,
  xs = 12,
  md = 6,
  lg = 4,
  gridOptions,
  tooltip,
  ...props
}) => {
  const shouldHide = typeof isHidden === "function" ? isHidden() : isHidden;
  if (shouldHide) return null;

  return (
    <Grid item xs={xs} md={md} lg={lg} {...gridOptions}>
      <div style={{ display: "flex", alignItems: "center", marginLeft: 7 }}>
        <PTTypography
          color="primary"
          style={{
            fontWeight: 550,
            marginRight: 7,
            display: 'inline',
          }}
        >
          <PTTranslate tk={label} /> :
          {tooltip && (
            <PTTooltip title={tooltip}>
              <Box
                style={{
                  marginLeft: 3,
                  display: "inline-block",
                  borderRadius: "50%",
                  backgroundColor: "#F1F1F1",
                  padding: 2,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "-10px",
                }}
              >
                <PTIcon
                  icon={"QuestionMarkIcon"}
                  sx={{ height: 8, width: 8 }}
                />
              </Box>
            </PTTooltip>
          )}
        </PTTypography>
        <Typography
          variant="body1"
          color="primary"
          style={{
            display: 'inline',
            wordBreak: "break-word",
          }}
        >
          {value || "-"}
        </Typography>
      </div>
    </Grid>
  );
};

export default PTTextDisplay;
